<a id="{{componentId}}" href="javascript:void(0);" [class]="class" [attr.data-activates]="componentId + '-dropdown'">
	<ng-content></ng-content>
</a>
<ul id="{{componentId}}-dropdown" class="{{listClass}} dropdown-content">
	<ng-content select="div[role=header]"></ng-content>
	<ng-content select="dropdown-button-item"></ng-content>
	<ng-content select="div[role=footer]"></ng-content>
</ul>